<template> 
<div class="categories-page">
  <div class="page-header">
    <h1>Categories</h1>
    <div v-if="!viewFolder" class="main-page-actions">
      <button class="add-btn folder-btn" @click="showNewFolderModal = true">
        <i class="fas fa-plus" style="color: white; margin-right: 6px;"></i>
        Create Folder
      </button>
    </div>
    <div v-if="viewFolder" class="actions">
      <button class="add-btn folder-btn" @click="showNewFolderModal = true">
        <i class="fas fa-plus" style="color: white; margin-right: 6px;"></i>
        {{ viewFolder ? 'Create Subfolder' : 'Create Folder' }}
      </button>
      <button class="add-btn clinic-btn" @click="openAddClinicModal">
        <i class="fas fa-plus" style="color: white; margin-right: 6px;"></i>
        Add Clinic
      </button>
    </div>
  </div>
    
  <!-- Breadcrumb -->
  <div class="breadcrumb" v-if="viewFolder && (getCurrentFolderPath || getCategoriesViewFolders.length)">
    <span v-if="breadcrumbPath.length > 0" @click="resetViewFolder">
      <svg xmlns="http://www.w3.org/2000/svg" 
        width="24" height="24" 
        viewBox="0 0 24 24" 
        fill="none" stroke="#3498db" stroke-width="2" 
        stroke-linecap="round" stroke-linejoin="round"
        class="back-icon">
        <circle cx="12" cy="12" r="11" stroke="#3498db"/>
        <polyline points="12 8 8 12 12 16"/>
        <line x1="16" y1="12" x2="8" y2="12"/>
      </svg>
    </span>
      <!-- <div class="breadcrumb" v-if="viewFolder && (getCurrentFolderPath || getCategoriesViewFolders.length)"> -->

    <span v-for="(crumb, index) in ['Categories', ...breadcrumbPath]" :key="index">
      <span @click="goToBreadcrumb(index)" style="cursor:pointer">
        {{ crumb }}
      </span>
      <span> > </span>
    </span>
  </div>

  <div v-if="viewFolder" class="folder-heading">
    <h2>{{ viewFolder.data.folderName }}</h2>
  </div>
  <div v-if="showNewFolderModal" class="modal-overlay">
    <div class="modal">
      <h2>Enter New Folder Name</h2>
      <input
        type="text"
        v-model="tempFolderName"
        placeholder="Folder name"
        class="modal-input"
      />
      <div class="modal-buttons">
        <button class="save-btn" @click="saveNewFolder">Save</button>
        <button class="cncl-btn" @click="showNewFolderModal = false">Cancel</button>
      </div>
    </div>
  </div>

  <!-- Add Clinic Modal -->
  <div v-if="showAddClinicModal" class="modal-overlay">
    <div class="modal-window">
      <h2>Select Clinics to Add</h2>

          <!-- Clinic list -->
      <div class="clinic-list">
        <table class="clinic-table">
          <thead>
            <tr>
              <th>Select</th>
              <th>Clinic Name</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="clinic in allClinics" :key="clinic.id">
                  <td>
                    <input
                      type="checkbox"
                      :value="clinic.id"
                      v-model="selectedClinics"
                    />
                  </td>
              <td>{{clinic.name}}</td>
            </tr>
            <tr v-if="!allClinics.length">
              <td colspan="2" style="text-align:center; color:gray;">No clinics available</td>
            </tr>
          </tbody>
        </table>
      </div>

          <!-- Buttons -->
      <div class="modal-buttons">
        <button class="confirm-btn" @click="addSelectedClinics">Add Selected</button>
        <button class="cancel-btn" @click="showAddClinicModal = false">Cancel</button>
      </div>
    </div>
  </div>

  <!-- Folders Table -->
     <!-- todo -->
    <div class="table-container" 
      :class="{ 'subfolder-table-container': viewFolder }">
    <table v-if="getCategoriesViewFolders.length" class="folder-table">
      <thead>
        <tr>
          <th>Folder Name</th>
          <th>No. of Clinics</th>
          <th>Stats</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="folder in getCategoriesViewFolders" :key="folder.id">
          <td @click="openFolder(folder)" style="cursor:pointer">
              📁 {{ folder.data.folderName }} </td>
            <td style="color:black">
              {{ folder.totalClinics ?? folder.clinics?.length ?? 0 }} </td>
            <td @click="openStats(folder)" style="cursor:pointer; color:black">
              Show Stats
          </td>
          <td>
              <button v-if="folder.data?.folderId"
              @click="requestDeleteFolder(folder.data.folderId)"
              class="fas fa-trash action-icon delete-btn">
            </button>
          </td>
        </tr>
        <tr v-if="!getCategoriesViewFolders.length">
          <td colspan="4" style="text-align:center; color:gray;">No subfolders</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Clinics Table -->
     <!-- todo -->
  <div class="clinic-table-container">
    <table v-if="viewFolder && getCurrentFolderPath" class="clinic-table">
      <thead>
        <tr>
          <th>Clinic Name</th>
          <th>Stats</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="clinic in clinics" :key="clinic.id">
          <td>{{ clinic.data.clinicName??"-" }}</td>
          <td @click="openStats(clinic)" style="cursor:pointer">Show Stats</td>
          <td>
            <!-- @click="deleteClinic(clinic.data.clinicLinkId)"  -->
            <button 
              @click="deleteClinic(clinic.data.clinicLinkId, viewFolder.data.folderId)"
              class="fas fa-trash action-icon delete-btn">
            </button>
          </td>
        </tr>
        <tr v-if="!clinics.length">
          <td colspan="3" style="text-align:center; color:gray;">No clinics</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div v-if="showDeleteModal" class="modal-overlay">
  <div class="modal">
    <h2>Confirm Delete</h2>
    <p>Are you sure you want to delete this folder?</p>
    <div class="modal-buttons">
      <button class="confirm-btn" @click="confirmDelete">Yes, Delete</button>
      <button class="cancel-btn" @click="cancelDelete">Cancel</button>
    </div>
  </div>
</div>
<div v-if="showDeleteClinicModal" class="modal-overlay">
  <div class="modal">
    <h2>Confirm Delete</h2>
    <p>Are you sure you want to delete this clinic?</p>
    <div class="modal-buttons">
      <button class="confirm-btn" @click="confirmDeleteClinic">Yes, Delete</button>
      <button class="cancel-btn" @click="showDeleteClinicModal = false">Cancel</button>
    </div>
  </div>
</div>

<KibanaIframe
  v-if="showKibanaIframe"
  :src="kibanaIframeUrl"
  @close="showKibanaIframe = false"
/>

<!-- Popup -->
<div v-if="popup.show" :class="['popup', popup.type]">
  {{ popup.message }}
</div>
</template>

<script>
import { getClinicsInFolder } from "@/store/folderClinic";
import { mapGetters, mapState, mapActions } from "vuex";
import KibanaIframe from "@/views/KibanaIframe.vue";
import { generateMultipleClinicIdDashboardLink } from "@/utils";

// import axios from "axios";

export default {
  name: "CategoriesView",
  components: { KibanaIframe },
  data() {
    return {
      // viewFolder: null,
      // clinics: [],
      showKibanaIframe: false,
      kibanaIframeUrl: "",
      showDeleteModal: false,
      showNewFolderModal: false,
      tempFolderName: "",
      showAddClinicModal: false,
      selectedClinics: [] ,
      allClinics:[],
      folderToDelete: null,
      showDeleteClinicModal: false,
      clinicToDelete: null,
      currentFolderId: null,
      popup: {
      show: false,
      message: "",
      type: "" // success | error | info
      },
    };
  },
  computed: {
    // ...mapGetters(["folders"]),
    ...mapGetters("folderClinic", ["getCategoriesViewFolders", "getCurrentFolderPath", "getTotalClinicCount", "getFolderByPath"]),
    ...mapState(["clinics"]),
    
    breadcrumbPath() {
      return this.getCurrentFolderPath?.split("/") ?? [];
    },
    clinics() {
      return this.viewFolder ? this.directClinics(this.viewFolder) : [];
    },
    viewFolder() {
      return this.getFolderByPath(this.getCurrentFolderPath) || null;
    },
    getClinics() {
    return this.clinics || [];
  },
    
  },
  async mounted() {
    this.$store.commit("folderClinic/SET_CURRENT_FOLDER_PATH", null);
    try {
      await this.$store.dispatch("folderClinic/fetchFolderStructure");
    } catch (error) {
      console.error("Failed to load folder structure:", error);
    }
  // console.log("folderStructure =", this.$store.state.folderStructure);
    this.$store.dispatch("fetchClinics")
  },

  watch: {
    viewFolder: {
      handler(newVal) {
        if(!newVal) {
          this.clinics = [];
          return;
        }
        this.clinics = getClinicsInFolder(newVal);
      },
    },
  },
  methods: {
    ...mapActions(["fetchClinics", "folderClinic/addClinicsToFolder"]),

    showPopup(message, type = "info") {
      this.popup.message = message;
      this.popup.type = type;
      this.popup.show = true;
      setTimeout(() => {
        this.popup.show = false;
        }, 3000); // auto-close
      },

    goToBreadcrumb(index) {
      const path = this.breadcrumbPath.slice(0, index ).join("/");
      this.$store.commit("folderClinic/SET_CURRENT_FOLDER_PATH", path.length > 1 ? path : null);
    },
    
    openFolderModal() {
      this.showFolderModal = true;
    },

    async saveNewFolder() {
      const folderNameTrimmed = this.tempFolderName.trim();
      if (!folderNameTrimmed) {
        this.showPopup("Folder name cannot be empty", "error");
        return;
      }

      // current folder as parent
      const parentFolderId = this.viewFolder?.data?.folderId ?? null;

      // Get existing folders/subfolders in the current folder
      const existingFolders = this.viewFolder?.data?.items?.filter(f => f.type === "folder") || [];
  
      // Check for duplicates
      const duplicate = existingFolders.some(
        f => f.data.folderName.toLowerCase() === folderNameTrimmed.toLowerCase()
      );
      if (duplicate) {
        this.showPopup("A folder or subfolder with this name already exists", "error");
        return;
      }

      try {
        await this.$store.dispatch("folderClinic/createFolder", {
          folderName: folderNameTrimmed,
          parentFolderId
        });
        this.showPopup("Folder created successfully!", "success");
        this.showNewFolderModal = false;

        this.tempFolderName = "";

        // Refresh folder structure
        await this.$store.dispatch("folderClinic/fetchFolderStructure");
      } catch (error) {
        console.error("Failed to create folder:", error);
        this.showPopup("A folder or subfolder with this name already exists", "error");
      }
    },

    async openAddClinicModal() {
  this.showAddClinicModal = true;
  this.selectedClinics = [];

  try {
    // Dispatch Vuex action to fetch latest clinics
    await this.$store.dispatch("fetchClinics");

    // After fetching, read from the store
    const storeClinics = this.$store.state.clinics || [];

    // Map clinics for the modal
    this.allClinics = storeClinics.map(c => ({
      id: c.clinicLinkId || c.id,
      name: c.name || c.clinicName
    }));

    console.log("Fetched clinics:", this.allClinics);

    if (!this.allClinics.length) {
      this.showPopup("No clinics available to add", "error");
    }
  } catch (error) {
    console.error("Error fetching clinics:", error);
    this.showPopup("Failed to load clinics", "error");
  }
},

async addSelectedClinics() {
  // 1. Ensure a folder is selected
  const rawFolderId = this.viewFolder?.data?.folderId;
  const folderId =
    rawFolderId === null || rawFolderId === undefined || rawFolderId === ""
      ? null
      : Number(rawFolderId);
  if (!folderId || Number.isNaN(folderId)) {
    this.showPopup("Please open/select a folder first", "error");
    return;
  }
  // 2. Ensure at least one clinic is selected
  const selectedClinicIds = Array.isArray(this.selectedClinics)
    ? this.selectedClinics
    : [];
  if (!selectedClinicIds.length) {
    this.showPopup("Please select at least one clinic!", "error");
    return;
  }
  // 3. Get details for all selected clinics
  const allClinics = this.$store.getters.getClinics || [];
  const selectedClinicDetails = selectedClinicIds.map(selId => {
    const clinic = allClinics.find(
      c => String(c.id) === String(selId) || String(c.clinicLinkId) === String(selId)
    );
    return {
      id: clinic?.id ?? selId,
      clinicLinkId: clinic?.clinicLinkId ?? clinic?.link ?? null,
      clinicName: clinic?.clinicName ?? clinic?.name ?? null
    };
  }).filter(c => c.clinicLinkId); // We still need the linkId to add it
  // 4. Get clinic names that are *already* in the current folder
  const currentFolder = this.viewFolder;
  if (!currentFolder || !currentFolder.data) {
      this.showPopup("Error finding current folder", "error");
      return;
  }
  const existingClinics = currentFolder.data.items?.filter(i => i.type === "clinic") || [];
  // 5. Extract existing clinic NAMES and log them
  const existingClinicNamesInFolder = existingClinics.map(c => {
    const clinicName = c.data?.clinicName;
    return clinicName;
  }).filter(Boolean);
  const existingClinicNames = new Set(existingClinicNamesInFolder);
  // 6. Separate selected clinics into "new" and "duplicate" lists
  const newClinics = [];
  const duplicateClinics = [];
  for (const clinic of selectedClinicDetails) {
    const nameToAdd = clinic.clinicName;
    // const nameType = typeof nameToAdd;
    const isDuplicate = existingClinicNames.has(nameToAdd);
    if (isDuplicate) {
      duplicateClinics.push(clinic);
    } else {
      newClinics.push(clinic);
    }
  }
  // 7. Handle the logic based on what was found
  if (newClinics.length === 0) {
    this.showPopup("Clinics already exists", "error");
    return;
  }
  // 8. Scenario: AT LEAST ONE new clinic was found
  const clinicLinkIdsToAdd = newClinics.map(c => c.clinicLinkId);
  const clinicNamesToAdd = newClinics.map(c => c.clinicName ?? c.clinicLinkId);
  try {
    await this.$store.dispatch("folderClinic/addClinicsToFolder", {
      folderId,
      clinicLinkIds: clinicLinkIdsToAdd,
      clinicNames: clinicNamesToAdd
    });
    this.showPopup("New clinics added to the Selected Folder", "success");
    this.closeAddClinicModal();
    await this.$store.dispatch("folderClinic/fetchFolderStructure");
  } catch (err) {
    console.error("Error adding clinics to folder:", err);
    this.showPopup("Failed to add clinics.", "error");
  }
},


    closeAddClinicModal() {
      this.showAddClinicModal = false;
      this.selectedClinics = [];
      this.allClinics = [];
    },

    openFolder(folder) {
      this.$store.commit( "folderClinic/SET_CURRENT_FOLDER_PATH",
      this.getCurrentFolderPath
        ? this.getCurrentFolderPath + "/" + folder.data.folderName
        : folder.data.folderName
      );
    },

    resetViewFolder() {
      const parts = this.getCurrentFolderPath?.split("/") || [];
      parts.pop(); // remove current folder
      const newPath = parts.length ? parts.join("/") : null;
      // Update store
      this.$store.commit("folderClinic/SET_CURRENT_FOLDER_PATH", newPath);
      if (!newPath) {
        //  Root reached
        this.clinics = [];
        this.$router.push("/categories"); // navigate to categories page
      } else {
        // update viewFolder and clinics
        const parentFolders = this.$store.getters["folderClinic/getCategoriesViewFolders"] || [];
        const lastFolderName = parts[parts.length - 1];
        const found = parentFolders.find(f => f.data.folderName === lastFolderName);
        this.viewFolder = found || null;
        this.clinics = found ? getClinicsInFolder(found) : [];
      }
    },
    // openStats(folder) {
    //   if(folder.disabled) return;

    // },

    findFolder(folders = [], folderId) {
      for (const folder of folders) {
        if (folder.data.folderId === folderId) return folder;
        if (folder.children?.length) {
          const found = this.findFolder(folder.children, folderId);
          if (found) return found;
        }
      }
      return null;
    },

    directClinics(folder) {
      if (!folder || !folder.data?.items) return [];
      return folder.data.items.filter(item => item.type === "clinic");
    },

    getClinicCount(folder) {
      let count = (folder.clinics?.length || 0);
      const children = folder.children || folder.folders || [];
      for (const sub of children) {
        count += this.getClinicCount(sub);
      }
      return count;
    },
 openStats(item) {
      // Collect clinic IDs recursively
      const collectClinicIds = (node, ids = []) => {
        if (!node) return ids;
        if (node.type === "clinic") {
          if (!ids.includes(node.data.clinicLinkId)) ids.push(node.data.clinicLinkId);
        } else if (node.type === "folder" && node.data?.items) {
          node.data.items.forEach(child => collectClinicIds(child, ids));
        }
        return ids;
      };

      const ids = collectClinicIds(item);
      if (!ids.length) return alert("No clinics found!");


      this.kibanaIframeUrl = generateMultipleClinicIdDashboardLink(ids);

      this.showKibanaIframe = true;
    },  
  async deleteClinic(clinicLinkId, folderId) {
    // console.log("Clinic:", clinicLinkId, "Folder:", folderId);
    this.clinicToDelete = { clinicLinkId, folderId };  
    this.showDeleteClinicModal = true; 
  },

async confirmDeleteClinic() {
  try {
    const { clinicLinkId, folderId } = this.clinicToDelete; 
    await this.$store.dispatch("folderClinic/deleteClinic", { clinicLinkId, folderId });
    // Re-fetch structure
    await this.$store.dispatch("folderClinic/fetchFolderStructure");

    // Find updated folder from store by folderId
    const updatedFolder = this.$store.getters["folderClinic/getCategoriesViewFolders"]
      .find(f => f.type === "folder" && f.data.folderId === this.viewFolder?.data.folderId);

    this.viewFolder = updatedFolder || null;
    this.clinics = updatedFolder ? getClinicsInFolder(updatedFolder) : [];

    this.showPopup("Clinic Deleted Successfully", "success");
  } catch (error) {
    console.error("Failed to delete clinic:", error);
    this.showPopup("Failed to delete clinic, please try again", "error");
  } finally {
    this.showDeleteClinicModal = false;
    this.clinicToDelete = null;
  }
},
  requestDeleteFolder(folderId) {
    this.folderToDelete = folderId;
    this.showDeleteModal = true;
  },

  async confirmDelete() {
    try {
      await this.$store.dispatch("folderClinic/deleteFolder", this.folderToDelete);
    } catch (error) {
      alert("Failed to delete folder");
    } finally {
      this.showPopup("Folder Deleted Successfully", "success");
      this.showDeleteModal = false;
      this.folderToDelete = null;
    }
  },

  cancelDelete() {
    this.showDeleteModal = false;
    this.folderToDelete = null;
  },


  },
};
</script>

<style scoped>
.categories-page {
  padding: 20px;
  height: 100vh;
  background-image: url("@/assets/login-bg-desktop.svg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.back-icon{
  margin-right: 20px;
  cursor: pointer;
}

/* Breadcrumb */
.breadcrumb {
  margin-bottom: 15px;
  font-weight: 500;
}
.breadcrumb-item {
  cursor: pointer;
  
}

.breadcrumb span {
  color: #007acc;              
  cursor: pointer;             
  position: relative;
  top: -5px;             
}

.main-page-actions{
  display: flex;
  flex-direction: row-reverse;

}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.actions {
  flex-direction: row-reverse;    
  display: flex;
  gap: 10px;
}

.add-btn {
  align-items: flex-end;
  background-color: #3498db;
  border: none;
  color: white;
  padding: 8px 16px;
  font-size: 14px;
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}


@media (max-width: 480px) {
  h2 {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  
  .actions {
    margin-right: 0%;
    margin-bottom: 10px;
  }

  .add-btn {
    padding: 8px;
    font-size: 12px;
  }

  .breadcrumb {
    margin-top: 20px;
    margin-bottom: 10px;
    }

  .subfolder-table-container, .clinic-table-container {
    max-height: 200px !important;
  }

  .modal {
    width: 95%;
    padding: 15px;
  }
}
@media (max-width: 600px) {
  .actions {
    flex-direction: column;  
    align-items: stretch;    
  }

  .actions .add-btn {
    width: 100%;             
  }
}

.add-btn:hover {
  background-color: rgba(0, 97, 138, 1);
}

.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
}

.modal {
  background: white;
  padding: 20px;
  border-radius: 12px;
  width: 400px;
}

.modal-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.modal-input {
  width: 90%;
  padding: 10px 14px;
  border: 1px solid #ccc;
  border-radius: 12px;  /* rounded corners */
  outline: none;
  font-size: 14px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.modal-input:focus {
  border-color: #3498db;
  box-shadow: 0 0 5px rgba(52, 152, 219, 0.4);
}

.save-btn {
  padding: 8px 16px;
  background: #3498db;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.save-btn:hover {
  background: #2c3e50;
}

.cncl-btn {
  padding: 8px 16px;
  background: #e74c3c;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.cncl-btn:hover {
  background: #c0392b;
}

.modal-window {
  background: #fff;
  padding: 20px 25px;
  border-radius: 10px;
  width: 500px;
  max-height: 75vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  position: relative;
}

.modal-window h2 {
  margin-bottom: 15px;
  color: #333;
}

.clinic-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 20px;
  max-height: 50vh;
  overflow-y: auto;
}

.clinic-item {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333;
}

.clinic-item input {
  margin-right: 8px;
  transform: scale(1.1);
}

.confirm-btn,
.cancel-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
}

.confirm-btn {
  background-color: #3498db;
  color: white;
  margin-right: 10px;
}

.cancel-btn {
  background-color: #ddd;
}

.confirm-btn:hover {
  background-color: #00618a;
}

/* Clinic table inside modal */
.modal-window .clinic-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  margin-top: 10px;
}

.modal-window .clinic-table th {
  position: sticky;
  top: 0;
  background: #3498db;
  color: white;
  padding: 10px;
  text-align: left;
}

.modal-window .clinic-table td {
  padding: 10px;
  border-bottom: 1px solid #ddd;
  color: black;
}

.modal-window .clinic-list {
  max-height: 300px;
  overflow-y: auto;
  margin-bottom: 20px;
}

.modal-window .clinic-list::-webkit-scrollbar {
  width: 8px;
}

.modal-window .clinic-list::-webkit-scrollbar-thumb {
  background-color: #3498db;
  border-radius: 10px;
}



.table-container {
  max-height: 450px;      
  overflow-y: auto;
  overflow-x: hidden;
  margin: auto;
  width: 100%;
  border-radius: 12px;
  /* background: white; */
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  scrollbar-width: thin;        /* Firefox */
  scrollbar-color: #3498db #f1f1f1; /* Firefox colors */
}

.subfolder-table-container {
  max-height: 230px;
  margin-bottom: 20px;
}

/* Chrome / Edge / Safari custom scrollbar */
.table-container::-webkit-scrollbar {
  width: 10px;
}

.table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.table-container::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #3498db, #2c80b4);
  border-radius: 10px;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #2c80b4, #1c5f8a);
}


/* Table */
.folder-table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 12px;
  /* margin: 2%; */
  background: white;
}
.folder-table th {
  position: sticky;
  top: 0;                    
  z-index: 10;
  background: #3498db;
  color: white;
  text-align: left;
  padding: 12px;
  border-bottom: 1px solid #ddd;
}

.folder-table td {
  text-align: left;
  padding: 12px;
  border-bottom: 1px solid #ddd;
}

.clinic-table-container {
  max-height: 230px;      
  overflow-y: auto;
  overflow-x: hidden;
  margin: auto;
  width: 100%;
  border-radius: 12px;
  /* background: white; */
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  scrollbar-width: thin;        /* Firefox */
  scrollbar-color: #3498db #f1f1f1; /* Firefox colors */
}

/* Chrome / Edge / Safari custom scrollbar */
.clinic-table-container::-webkit-scrollbar {
  width: 10px;
}

.clinic-table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.clinic-table-container::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #3498db, #2c80b4);
  border-radius: 10px;
}

.clinic-table-container::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #2c80b4, #1c5f8a);
}

.clinic-table{
  width: 100%;
  border-collapse: collapse;
  border-radius: 12px;
  /* margin: 2%; */
  background: white;
}
.clinic-table th {
  position: sticky;
  top: 0;                     
  z-index: 10;
  background: #3498db;
  color: white;
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}
.clinic-table td {
  color: black;
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.folder-table thead,
.clinic-table thead {
  display: table-header-group;
}

/* Delete button */
.delete-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  transition: transform 0.2s ease, opacity 0.2s ease;
}
.delete-btn:hover {
  transform: scale(1.1);
  opacity: 0.8;
}
.folder-name {
  color: #007acc;
  text-decoration: none;
  cursor: pointer;
}
.disabled-folder-text {
  color: black !important;
  text-decoration: none !important;
  cursor: not-allowed !important;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.modal {
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  width: 320px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}

.modal h2 {
  margin-bottom: 10px;
  font-size: 18px;
}

.modal-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.confirm-btn {
  background: #007acc;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
}

.confirm-btn:hover {
  background: #00618a;
}

.cancel-btn {
  background: #e74c3c;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
}

.cancel-btn:hover {
  background: #c0392b;
}
.popup {
  position: fixed;
  top: 20px;
  right: 10%;
  background: rgba(0, 97, 138, 1);
  color: white;
  padding: 12px 20px;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.2);
  transition: opacity 0.3s ease-in-out;
  z-index: 3000;
}
.popup.error {
  background: rgba(0, 97, 138, 1);
  color: white;
}
.popup.info {
  background: rgba(0, 97, 138, 1);
  color: white;
}
.action-icon {
  color: #e74c3c;
}
.action-icon:hover {
  opacity: 0.7;
}
</style>
